<template>
  <div class="body_monban" >
    <el-tabs  style="height: 200px;" v-model="activeName">
    <el-tab-pane label="提现" name="tixian"><tixian :admin_flag="0"></tixian></el-tab-pane>
    <el-tab-pane label="客户退款" name="tuikuan"><tuikuan :admin_flag="1"></tuikuan></el-tab-pane>
    <!-- <el-tab-pane label="股东明细" name="gudongMingxi"><gudongMingxi :admin_flag="0"></gudongMingxi></el-tab-pane> -->
  </el-tabs>

  </div>
</template>
<style>
.body_moban{
  padding-top: 100px;
}
</style>
<script>
import tixian from '../../tongyong/tixian.vue';
import tuikuan from '../../tongyong/tuikuan.vue';
// import gudongMingxi from '../../tongyong/gudong_mingxi.vue';
export default {
  components: {
    tixian: tixian,
    tuikuan: tuikuan 
  },

  data() {
    return {
      // 获取用户列表参数
      activeName: 'tixian'
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
